$(document).ready(function () {
    if ($('.page-navigation').length) {
        var pageNavigation = $('.page-navigation');
        var body = $('body');
        var navOffsetTop = pageNavigation.offset().top;

        $(window).on('scroll', function () {
            var scrollTop = $(window).scrollTop();

            if (scrollTop >= navOffsetTop) {
                pageNavigation.addClass('__sticky');
                body.addClass('__scrolled');
            } else {
                pageNavigation.removeClass('__sticky');
                body.removeClass('__scrolled');
            }
        });
    }
});
